/* eslint-disable */
import {AfterViewInit, Component, ViewChild,} from '@angular/core';
import {
  FormEditFieldCreateDialogView,
  FormEditFieldDialogContext,
  FormEditFieldUpdateDialogView,
  FormGroupModel,
  FormModel,
} from '../../../../../../../util/form/form-utils';
import {InputMask} from '../../../../../../../util/input-masks';
import {Form} from '../../../../../../../lib/form/form.service';
import {ModalDirective} from 'ngx-bootstrap/modal';
import {FieldWidthType} from '../../../../../../../util/form/form-field-width-type';
import {
  FieldValidationError,
  FormRef,
  LocalFieldValidationErrors,
  LocalFieldValidationErrorsFactory,
  QueryResult,
  ResourceQueryResult,
} from '../../../../../../../lib/util/services';
import {NgModel} from '@angular/forms';
import {List, Set} from 'immutable';
import {
  FieldValidationType,
  FormFieldValidationTypeModel,
} from '../../../../../../../util/form/form-field-validation-type';
import {Models} from '../../../../../../../util/model-utils';
import {
  StockItemCategory,
  StockItemCategoryService
} from '../../../../../../../lib/stock-item-category/stock-item-category.service';
import {MultiselectOptionItem, OptionItem, UiConstants} from '../../../../../../../util/core-utils';
import {Angular2Multiselects} from '../../../../../../../util/multiselect';
import {StringKey} from '../../../../../../../app.string-keys';
import {TranslateService} from '@ngx-translate/core';
import {Strings} from '../../../../../../../lib/util/strings';
import {ToasterService} from '../../../../../../../fork/angular2-toaster/src/toaster.service';
import {
  INTAKE_SUPPLIER_TYPES,
  StockIntakeSupplierType,
  StockType,
  StockTypeName
} from '../../../../../../../util/stock/stock-utils';
import {Stock, StockService} from '../../../../../../../lib/stock/stock.service';

/* eslint-enable */

@Component({
  selector: 'app-form-edit-create-update-stock-intake-field-dialog',
  templateUrl: 'form-edit-create-update-stock-intake-field-dialog.component.html',
  styleUrls: ['form-edit-create-update-stock-intake-field-dialog.component.scss'],
})
export class FormEditCreateUpdateStockIntakeFieldDialogComponent
  implements FormEditFieldCreateDialogView, FormEditFieldUpdateDialogView, FormRef, AfterViewInit {

  public readonly selector = Form.FieldDataTypeSelector.STOCK_INTAKE;
  public readonly createTitle = 'FORM_ITEM_CREATE_STOCK_INTAKE_TITLE';
  public readonly updateTitle = 'FORM_ITEM_UPDATE_STOCK_INTAKE_TITLE';
  public readonly cloneTitle = 'FORM_ITEM_CLONE_STOCK_INTAKE_TITLE';

  InputMask = InputMask;
  Form = Form;
  UiConstants = UiConstants;

  @ViewChild('fieldDialog', {static: true})
  dialogComponent: ModalDirective;

  @ViewChild('title')
  titleInput: NgModel;

  @ViewChild('api_export_name')
  apiExportNameInput: NgModel;

  @ViewChild('usableStockItemCategories')
  usableStockItemCategories: NgModel;

  visible: boolean = false;
  fieldModel: Model = new Model();
  dialogTitleDictionaryKey: string = '';
  latestApiExportName = '';

  typeDropdownSettings?: Angular2Multiselects.Settings;
  categoryDropdownSettings?: Angular2Multiselects.Settings;
  stockDropdownSettings?: Angular2Multiselects.Settings;
  supplierTypeDropdownSettings?: Angular2Multiselects.Settings;

  fieldWidthTypes: FieldWidthType[] = FieldWidthType.VALUES.toArray();
  fieldValidationTypes: Form.FormFieldValidationType[] = FieldValidationType.VALUES
    .toArray();

  private fieldErrors: FieldValidationError<Form.FieldValidatedField> =
    FieldValidationError.empty<Form.FieldValidatedField>();

  private validatedInputs: LocalFieldValidationErrors<NgModel> =
    LocalFieldValidationErrorsFactory.empty();

  private context: FormEditFieldDialogContext;
  private group: FormGroupModel;
  private field?: Form.Field;
  private clone?: boolean;
  private submitted: boolean = false;

  stockTypes: MultiselectOptionItem<StockTypeName>[] = StockType.VALUES.toArray().map(t => t.toMultiselectOptionItem());
  stockItemCategoryItems: StockItemCategoryItem[] = [];
  destinationStocks: MultiselectOptionItem<number>[] = [];
  supplierTypes: MultiselectOptionItem<StockIntakeSupplierType>[] = INTAKE_SUPPLIER_TYPES;

  private initDropDown() {
    this.typeDropdownSettings = new Angular2Multiselects.SettingsBuilder()
      .singleSelection(true)
      .enableSearchFilter(false)
      .enableCheckAll(false)
      .translate(true)
      .build();
    this.categoryDropdownSettings = new Angular2Multiselects.SettingsBuilder()
      .singleSelection(false)
      .enableSearchFilter(true)
      .enableCheckAll(false)
      .labelKey(OptionItem.KEY_TEXT)
      .text(StringKey.FORM_ITEM_STOCK_ALL_CATEGORIES)
      .remoteSearch(true)
      .build();
    this.stockDropdownSettings = new Angular2Multiselects.SettingsBuilder()
      .singleSelection(false)
      .enableSearchFilter(true)
      .enableCheckAll(true)
      .remoteSearch(true)
      .build();
    this.supplierTypeDropdownSettings = new Angular2Multiselects.SettingsBuilder()
      .singleSelection(true)
      .translate(true)
      .build();
  }

  getForm() {
    return {
      submitted: this.submitted
    };
  }

  ngAfterViewInit(): void {
    this.loadLocalFieldValidationErrors();
  }

  registerContext(context: FormEditFieldDialogContext): void {
    this.context = context;
  }

  showDialog(form: FormModel, group: FormGroupModel, field?: Form.Field, clone?: boolean): void {
    this.latestApiExportName = '';
    this.visible = true;
    this.group = group;
    this.clone = clone;
    this.dialogComponent.show();
    this.initDropDown();
    if (field && clone) {
      this.dialogTitleDictionaryKey = this.cloneTitle;
      this.loadField(field);
    } else if (field) {
      this.dialogTitleDictionaryKey = this.updateTitle;
      this.loadField(field);
    } else {
      this.dialogTitleDictionaryKey = this.createTitle;
    }
  }

  onModalHide(event: ModalDirective) {
    if (event.dismissReason === 'backdrop-click' || event.dismissReason === 'esc') {
      this.visible = false;
      this.submitted = false;
      this.fieldModel = new Model();
    }
  }

  closeDialog(): void {
    this.visible = false;
    this.submitted = false;
    this.dialogComponent.hide();
    this.fieldModel = new Model();
  }

  saveField() {
    this.submitted = true;
    if (this.hasLocalFieldError(this.titleInput)
      || this.hasLocalFieldError(this.apiExportNameInput)
      || this.hasLocalFieldError(this.usableStockItemCategories)) {
      return;
    }
    if (this.field && this.clone) {
      this.createField();
    } else if (this.field) {
      this.updateField(this.field);
    } else {
      this.createField();
    }
  }

  hasLocalFieldError(field?: NgModel): boolean {
    return this.validatedInputs.hasLocalError(field);
  }

  hasFieldError(field?: Form.FieldValidatedField): boolean {
    return this.fieldErrors.hasError(field);
  }

  removeFieldError(field: Form.FieldValidatedField) {
    this.fieldErrors = this.fieldErrors.removeError(field);
  }

  getFieldErrorText(field: Form.FieldValidatedField): string {
    return this.fieldErrors.getErrorText(field);
  }

  getFieldValidationTypeDictionaryKey(vt: Form.FormFieldValidationType): string {
    return FieldValidationType.getFieldValidationTypeDictionaryKey(vt);
  }

  onAdminFormFieldValidationTypeChanged() {
    FieldValidationType.onAdminFormFieldValidationTypeChanged(this.fieldModel);
  }

  onMobileFormFieldValidationTypeChanged() {
    FieldValidationType.onMobileFormFieldValidationTypeChanged(this.fieldModel);
  }

  private loadLocalFieldValidationErrors() {
    const validatedInputs = List.of(this.titleInput, this.apiExportNameInput, this.usableStockItemCategories);
    this.validatedInputs = LocalFieldValidationErrorsFactory.ofFields(this, validatedInputs);
  }

  private loadField(field: Form.Field) {
    this.field = field;
    const fieldWidth = FieldWidthType.fromPercentValue(field.formFieldWidthPercent);
    this.fieldModel.title = field.title;
    this.fieldModel.description = field.description ? field.description : '';
    this.fieldModel.apiExportName = field.apiExportName ? field.apiExportName : '';
    this.fieldModel.pdfExportName = field.pdfExportName ? field.pdfExportName : '';
    this.fieldModel.fieldWidthType = fieldWidth ? fieldWidth : FieldWidthType.FULL_SCREEN;
    this.fieldModel.adminVisibleOnFormDetail = field.admin.visibleOnFormDetail;
    this.fieldModel.mobileVisibleOnFormDetail = field.mobile.visibleOnFormDetail;
    this.fieldModel.mobileVisibleOnMasterDetail = field.mobile.visibleOnMasterDetail;
    this.fieldModel.adminFormFieldValidationType = field.admin.validationType;
    this.fieldModel.helpdeskFormFieldValidationType = field.helpdesk.validationType;
    this.fieldModel.mobileFormFieldValidationType = field.mobile.validationType;
    this.fieldModel.showOnReceipt = field.showOnReceipt;
    this.fieldModel.clearOnReopen = field.dataType.stockIntakeAttributes!.clearOnReopen;
    this.fieldModel.copyButtonVisible = field.dataType.stockIntakeAttributes!.copyButtonVisible;
    this.fieldModel.modifyStoredAmount = field.dataType.stockIntakeAttributes!.modifyStoredAmount;
    if (field.dataType.stockIntakeAttributes!.stockType) {
      this.fieldModel.stockType.push(StockType.fromName(field.dataType.stockIntakeAttributes!.stockType)!.toMultiselectOptionItem());
    }
    this.loadUsableStockItemCategoryIds(field.dataType.stockIntakeAttributes!.usableStockItemCategories);
    this.loadStockDestinationFilterIds(field.dataType.stockIntakeAttributes!.stockDestinationFilters);
    if (field.dataType.stockIntakeAttributes!.supplierType) {
      this.fieldModel.supplierType = this.supplierTypes.filter(s => s.id === field.dataType.stockIntakeAttributes!.supplierType);
    }
  }

  private createField() {
    this.context.formService.createField({
      parentId: this.context.parentId,
      groupId: this.group.groupId,
      title: this.fieldModel.title,
      description: this.fieldModel.description,
      pdfExportName: this.fieldModel.pdfExportName,
      apiExportName: this.fieldModel.apiExportName,
      dataTypeSelector: this.selector,
      dataType: this.getDataTypeRequest(),
      formFieldWidthPercent: this.fieldModel.fieldWidthType.percentValue,
      displayOnNewRow: false,
      admin: {
        visibleOnFormDetail: this.fieldModel.adminVisibleOnFormDetail,
        validationType: this.fieldModel.adminFormFieldValidationType
      },
      helpdesk: {
        validationType: this.fieldModel.helpdeskFormFieldValidationType
      },
      mobile: {
        visibleOnFormDetail: this.fieldModel.mobileVisibleOnFormDetail,
        visibleOnMasterDetail: this.fieldModel.mobileVisibleOnMasterDetail,
        validationType: this.fieldModel.mobileFormFieldValidationType
      },
      showOnReceipt: this.fieldModel.showOnReceipt
    }).subscribe(
      (result) => {
        this.context.formView.reloadForm();
        this.closeDialog();
      },
      (error) => {
        if (error instanceof FieldValidationError) {
          this.fieldErrors = error.withFormRef(this);
        }
      }
    );
  }

  private updateField(field: Form.Field) {
    this.context.formService.updateField({
      parentId: this.context.parentId,
      groupId: this.group.groupId,
      fieldId: field.fieldId,
      title: this.fieldModel.title,
      description: this.fieldModel.description,
      pdfExportName: this.fieldModel.pdfExportName,
      apiExportName: this.fieldModel.apiExportName,
      dataTypeSelector: this.selector,
      dataType: this.getDataTypeRequest(),
      formFieldWidthPercent: this.fieldModel.fieldWidthType.percentValue,
      displayOnNewRow: false,
      admin: {
        visibleOnFormDetail: this.fieldModel.adminVisibleOnFormDetail,
        validationType: this.fieldModel.adminFormFieldValidationType
      },
      helpdesk: {
        validationType: this.fieldModel.helpdeskFormFieldValidationType
      },
      mobile: {
        visibleOnFormDetail: this.fieldModel.mobileVisibleOnFormDetail,
        visibleOnMasterDetail: this.fieldModel.mobileVisibleOnMasterDetail,
        validationType: this.fieldModel.mobileFormFieldValidationType
      },
      showOnReceipt: this.fieldModel.showOnReceipt
    }).subscribe(
      (result) => {
        this.context.formView.reloadForm();
        this.closeDialog();
      },
      (error) => {
        if (error instanceof FieldValidationError) {
          this.fieldErrors = error.withFormRef(this);
        }
      }
    );
  }

  private getDataTypeRequest(): Form.FieldDataType {
    return {
      stockIntakeAttributes: {
        stockType: this.fieldModel.stockType.length === 1 ? this.fieldModel.stockType[0]!.id : undefined,
        usableStockItemCategories: this.getUsableStockItemCategoryIds(),
        supplierType: this.fieldModel.getSupplierType()!,
        stockDestinationFilters: this.getStockDestinationFilterIds(),
        clearOnReopen: this.fieldModel.clearOnReopen,
        copyButtonVisible: this.fieldModel.copyButtonVisible,
        modifyStoredAmount: this.fieldModel.modifyStoredAmount,
      }
    };
  }

  loadSupplierTypes() {

  }

  loadStockItemCategories(searchValue?: string) {
    this.stockItemCategoryService.query({
      name: Strings.undefinedOrNonEmpty(searchValue),
      disabled: false,
      paging: {
        pageNumber: 1,
        numberOfItems: UiConstants.autocompletePageSize
      },
      noProgressBar: true
    }).subscribe((result: QueryResult<StockItemCategory.StockItemCategory>) => {
      this.stockItemCategoryItems = [];
      result.items.forEach((category: StockItemCategory.StockItemCategory) => {
        const item = {
          id: category.id,
          text: category.name,
          disabled: category.disabled
        };
        this.stockItemCategoryItems.push(item);
      });
    });
  }

  getUsableStockItemCategoryIds(): number[] {
    const usableStockItemCategoryIds: number[] = [];
    this.fieldModel.usableStockItemCategories.forEach((stockItemCategoryItem: StockItemCategoryItem) => {
      if (stockItemCategoryItem.id) {
        usableStockItemCategoryIds.push(stockItemCategoryItem.id);
      }
    });
    return usableStockItemCategoryIds;
  };

  loadUsableStockItemCategoryIds(usableStockItemCategoryIds: number[]) {
    if (usableStockItemCategoryIds.length > 0) {
      this.stockItemCategoryService.query({
        id: Set.of(...usableStockItemCategoryIds)
      }).subscribe((result: QueryResult<StockItemCategory.StockItemCategory>) => {
        this.fieldModel.usableStockItemCategories = [];
        result.items.forEach((category: StockItemCategory.StockItemCategory) => {
          const item = {
            id: category.id,
            text: category.name,
            disabled: category.disabled
          };
          this.fieldModel.usableStockItemCategories.push(item);
        });
      });
    }
  };

  destinationStockTypeChanged(item?: MultiselectOptionItem<StockTypeName>) {
    this.loadDestinationStocks(undefined, item?.id);
  }

  loadDestinationStocks(searchValue?: string, type?: StockTypeName) {
    this.stockService.query({
      name: Strings.undefinedOrNonEmpty(searchValue),
      disabled: false,
      order: '+name',
      page_number: 1,
      number_of_items: UiConstants.autocompletePageSize,
      type: type,
      no_progress_bar: true
    }).subscribe((result: ResourceQueryResult<Stock>) => {
      this.destinationStocks = [];
      result.items.forEach((stock: Stock) => {
        const item = {
          id: stock.id,
          itemName: stock.name,
          itemSubtitle: stock.external_id,
          disabled: stock.disabled
        };
        this.destinationStocks.push(item);
      });
    });
  }

  getStockDestinationFilterIds(): number[] {
    const stockDestinationFilterIds: number[] = [];
    this.fieldModel.stockDestinationFilters.forEach((stockDestinationFilter: MultiselectOptionItem<number>) => {
      if (stockDestinationFilter.id) {
        stockDestinationFilterIds.push(stockDestinationFilter.id);
      }
    });
    return stockDestinationFilterIds;
  };

  loadStockDestinationFilterIds(stockDestinationFilterIds: number[]) {
    if (stockDestinationFilterIds.length > 0) {
      this.stockService.query({
        id: stockDestinationFilterIds.join(','),
        order: '+name',
        type: this.fieldModel.stockTypeName,
      }).subscribe((result: ResourceQueryResult<Stock>) => {
        this.fieldModel.stockDestinationFilters = [];
        result.items.forEach((stock: Stock) => {
          const item = {
            id: stock.id,
            itemName: stock.name,
            itemSubtitle: stock.external_id,
            disabled: stock.disabled
          };
          this.fieldModel.stockDestinationFilters.push(item);
        });
      });
    }
  };

  onTitleBlur() {
    const normalizedText = Models.normalizeText(this.fieldModel.title);
    if (this.fieldModel.apiExportName === '') {
      this.fieldModel.apiExportName = normalizedText;
    }
    if (this.fieldModel.pdfExportName === '') {
      this.fieldModel.pdfExportName = normalizedText;
    }
  }

  constructor(private stockItemCategoryService: StockItemCategoryService,
              private stockService: StockService,
              private toasterService: ToasterService,
              private translateService: TranslateService) {
  }
}

export class Model implements FormFieldValidationTypeModel {
  title: string = '';
  description: string = '';
  apiExportName: string = '';
  pdfExportName: string = '';
  fieldWidthType: FieldWidthType = FieldWidthType.FULL_SCREEN;
  adminVisibleOnFormDetail: boolean = true;
  mobileVisibleOnFormDetail: boolean = true;
  mobileVisibleOnMasterDetail: boolean = false;
  adminFormFieldValidationType: Form.FormFieldValidationType = Form.FormFieldValidationType.OPTIONAL;
  helpdeskFormFieldValidationType: Form.FormFieldValidationType = Form.FormFieldValidationType.OPTIONAL;
  mobileFormFieldValidationType: Form.FormFieldValidationType = Form.FormFieldValidationType.OPTIONAL;
  showOnReceipt?: boolean = false;
  clearOnReopen: boolean = false;
  copyButtonVisible: boolean = false;
  stockType: MultiselectOptionItem<StockTypeName>[] = [];
  usableStockItemCategories: StockItemCategoryItem[] = [];
  stockDestinationFilters: MultiselectOptionItem<number>[] = [];
  supplierType: MultiselectOptionItem<StockIntakeSupplierType>[] = [];
  modifyStoredAmount: boolean = true;


  getSupplierType(): StockIntakeSupplierType | undefined {
    return this.supplierType.length > 0 ? this.supplierType[0].id : undefined;
  }

  get stockTypeName(): StockTypeName | undefined {
    return this.stockType.length > 0 ? this.stockType[0].id : undefined;
  }
}

interface StockItemCategoryItem extends OptionItem<number> {
}
